import { isSameDay } from "@internationalized/date";
export function areDateRangeEquals(dateRange, dateRange2) {
  if (!dateRange.start || !dateRange.end || !dateRange2.start || !dateRange2.end) {
    return false;
  }
  return isSameDay(dateRange.start, dateRange2.start) && isSameDay(dateRange.end, dateRange2.end);
}
